/* eslint-disable @typescript-eslint/camelcase */
import { blankRx } from '~/modules/contentComment/contentComment.controller'
import * as _ from 'lodash'

export const emptyParagraphRegex = /^(\s*|<br[ /]*>)$/

const isEmptyContentElement = (contentElement) => {
  return (
    contentElement.type === 'text' &&
    emptyParagraphRegex.test(contentElement.content || '')
  )
}

export const removeEmptyParagraphs = (contentElements = []) => {
  //  if every content element is empty, preserve the first one (because we don't want to return 0 content elements)
  if (
    _.every(contentElements, (ce) => {
      return isEmptyContentElement(ce)
    })
  ) {
    return [contentElements[0]]
  }

  return contentElements.filter((c = {}) => {
    return !isEmptyContentElement(c)
  })
}

export const removeBRPlaceholders = (prevStory) => {
  prevStory.content_elements &&
    prevStory.content_elements.forEach((ce) => {
      if (
        ce.content &&
        ce.content.match(/^<br\s?\/?>$/) &&
        ce.additional_properties &&
        ce.additional_properties.inline_comments &&
        ce.additional_properties.inline_comments.length
      ) {
        ce.content = ''
      }
    })
  return prevStory
}

export const removeEmptyContentElementComments = (prevStory) => {
  return {
    ...prevStory,
    content_elements: (prevStory.content_elements || []).map((el) => {
      let commentsValue = (el.additional_properties || {}).comments || []

      if (Array.isArray(commentsValue)) {
        commentsValue = commentsValue.filter((comment) => {
          return blankRx.test(comment.text || '') === false
        })
      }

      return {
        ...el,
        additional_properties: {
          ...(el.additional_properties || {}),
          comments: commentsValue,
        },
      }
    }),
  }
}

export function initializePaywallStatus(prevStory) {
  const storyClone = _.cloneDeep(prevStory)

  // EL-2553 case 1b: Do nothing if template has a paywall status
  if (_.get(storyClone, 'content_restrictions.content_code')) {
    return storyClone
  }

  // EL-2553 case 1a: Set paywall status from primary website's primary section
  const primaryWebsite = storyClone.canonical_website
  const primaryWebsitePrimarySectionPaywallStatus = _.get(storyClone, [
    'websites',
    primaryWebsite,
    'website_section',
    'additional_properties',
    'original',
    'metadata',
    'content_code',
  ])
  if (primaryWebsitePrimarySectionPaywallStatus) {
    _.set(
      storyClone,
      'content_restrictions.content_code',
      primaryWebsitePrimarySectionPaywallStatus
    )
    return storyClone
  }

  // EL-2553 case 1a (old templates): Set paywall status from first section in sections
  const firstSectionPaywallStatus = _.get(
    storyClone,
    'taxonomy.sections[0].content_code'
  )
  if (firstSectionPaywallStatus) {
    _.set(
      storyClone,
      'content_restrictions.content_code',
      firstSectionPaywallStatus
    )
    return storyClone
  }

  return storyClone
}

// takes a string path "foo.bar.world" and traverses the provided object's tree
const objectResolver = (obj, path) => {
  return path
    .split('.')
    .reduce((prev, curr) => (prev ? prev[curr] : undefined), obj)
}

// Deletes the property given by the string path
const deleteProperty = (obj, path, deleteOnlyIfEmpty, deleteEmptyParents) => {
  const parts = path.split('.')
  const key = parts.pop()
  const remainingPath = parts.join('.')
  const parentObj = parts.length ? objectResolver(obj, remainingPath) : obj
  const shouldDelete =
    (deleteOnlyIfEmpty &&
      parentObj &&
      ['', null].indexOf(parentObj[key]) > -1) || // If the propery is null, or empty string
    (deleteOnlyIfEmpty &&
      parentObj &&
      typeof parentObj[key] === 'object' &&
      !Object.keys(parentObj[key]).length) || // if it is object with no keys
    (!deleteOnlyIfEmpty && parentObj && key in parentObj) // if we are just supposed to delete it.
  if (shouldDelete) {
    delete parentObj[key]
  }
  // Checks to see after we delete the key, if we need to wipe the object holding it if it no longer has any properties
  if (
    deleteEmptyParents &&
    typeof parentObj === 'object' &&
    !Object.keys(parentObj).length
  ) {
    deleteProperty(obj, remainingPath, deleteOnlyIfEmpty, deleteEmptyParents)
  }
}

const removeEmptyNullProperties = [
  'planning.scheduling.planned_publish_date',
  'planning.additional_properties',
  'websites',
  'distributor',
]
export const removeEmptyProperties = (story) => {
  removeEmptyNullProperties.forEach((path) =>
    deleteProperty(story, path, true, true)
  )
  return story
}
